import { makeStyles } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { Card, Steps, Button, notification, message } from 'antd'
import PropTypes from 'prop-types'
import { CheckCircleOutlined, ClockCircleOutlined, ExclamationOutlined, PlayCircleOutlined, StepForwardOutlined } from '@ant-design/icons'
import { useData } from '../../../../data'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { JobStatus } from '../../components'

const { Step } = Steps

const useStyles = makeStyles(theme => ({
    root: {
        display: props => props.show ? 'block' : 'none',
        marginBottom: theme.spacing(3)
    },
    action: {
        marginTop: theme.spacing(3)
    }
}))


// callback to start a job
const startJobCallback = (job, jobs, reload) => {
    console.log('Starting job')
    if (job) {
        const { id } = job

        trackPromise(
            jobs.scheduleRunJob(id)
                .then(reload)
                .catch(err => {
                    notification.error({
                        title: "Couldn't run job",
                        description: "There was a problem running job. See console for error"
                    })

                    console.log(err.message)
                })
        )
    }
}

// call back to run job details
const runDetailsCallback = (job, jobs, reload) => {
    console.log("Running details")
    if (job) {
        const { id } = job

        trackPromise(
            jobs.runDetails(id)
                .then(reload)
                .catch(err => {
                    notification.error({
                        title: "Couldn't fetch details",
                        description: "There was a problem running job. See console for error"
                    })

                    console.log(err.message)
                })
        )
    }
}

const runCompanyDetailsCallback = (job, jobs, reload) => {
    console.log("Running Company details")
    if (job) {
        const { id } = job

        trackPromise(
            jobs.runCompanyDetails(id)
                .then(reload)
                .catch(err => {
                    notification.error({
                        title: "Couldn't fetch details",
                        description: "There was a problem running job. See console for error"
                    })

                    console.log(err.message)
                })
        )
    }
}
//callback to collect emails
const collectEmailsCallback = (job, jobs, reload) => {
    console.log("Collect emails")
    if (job) {
        if (job) {
            const { id } = job

            trackPromise(
                jobs.collectEmails(id)
                    .then(reload)
                    .catch(err => {
                        notification.error({
                            title: "Couldn't collect emails",
                            description: "There was a problem running job. See console for error"
                        })

                        console.log(err.message)
                    })
            )
        }
    }
}

/**
 * Handle multi step jobs like contact scrapers
 *
 * Has buttons to proceed to the next step once a step is complete
 */
const MultiStepScheduler = ({ show, job, reload }) => {
    console.log("Job Tool Category", job.tool_category)
    const [steps, setSteps] = useState([])
    const [current, setCurrentStep] = useState(1)

    const classes = useStyles({ show })
    const data = useData()
    const jobs = data.jobs()
    const getJobStep1 = (job) => {
        const { status, stage } = job

        let step = {
            title: 'Collect Company Information',
            nextCallback: () => startJobCallback(job, jobs, reload),
            step: 1
        }

        if (stage === 1) {
            switch (status) {
                case 'PROCESSING':
                    step = {
                        ...step,
                        status: 'processing',
                        description: 'In progress'
                    }
                    break;
                case 'DONE':
                    step = {
                        ...step,
                        status: 'done',
                        description: "Done"
                    }
                    break;

                case 'ERROR':
                    step = {
                        ...step,
                        status: 'error',
                        description: 'Error'
                    }

                    break;

                default:
                    step = {
                        ...step,
                        status: 'pending',
                        description: 'Not started',
                        nextText: "Start job"
                    }

            }
        } else {
            step = {
                ...step,
                status: 'done',
                description: "Done"
            }
        }

        return step
    }

    const getJobStep2 = (job) => {
        let step = {
            title: 'Get Company Detail',
            nextCallback: () => runCompanyDetailsCallback(job, jobs, reload),
            step: 1,
        }

        // not started if step 1 ispending or in progress
        let { stage, status } = job

        if (stage === 2) {
            switch (status) {
                case 'PROCESSING':
                    step = {
                        ...step,
                        status: 'processing',
                        description: 'In progress'
                    }
                    break;
                case 'DONE':
                    step = {
                        ...step,
                        status: 'done',
                        description: "Done"
                    }
                    break;

                case 'ERROR':
                    step = {
                        ...step,
                        status: 'error',
                        description: 'Error'
                    }

                    break;

                default:
                    step = {
                        ...step,
                        status: 'pending',
                        description: 'Not started',
                        nextText: "Start job"
                    }

            }
        } else if (stage < 2) {
            step = {
                ...step,
                status: 'waiting',
                description: "Not started",
                nextText: 'Collect details',
            }
        } else {
            step = {
                ...step,
                status: 'done',
                description: "Done"
            }
        }



        return step
    }
    // generate the first step
    const getStep1 = (job) => {
        const { status, stage } = job

        let step = {
            title: 'Collect lead profile list',
            nextCallback: () => startJobCallback(job, jobs, reload),
            step: 1
        }

        if (stage === 1) {
            switch (status) {
                case 'PROCESSING':
                    step = {
                        ...step,
                        status: 'processing',
                        description: 'In progress'
                    }
                    break;
                case 'DONE':
                    step = {
                        ...step,
                        status: 'done',
                        description: "Done"
                    }
                    break;

                case 'ERROR':
                    step = {
                        ...step,
                        status: 'error',
                        description: 'Error'
                    }

                    break;

                default:
                    step = {
                        ...step,
                        status: 'pending',
                        description: 'Not started',
                        nextText: "Start job"
                    }

            }
        } else {
            step = {
                ...step,
                status: 'done',
                description: "Done"
            }
        }

        return step
    }

    const getStep2 = (job) => {
        let step = {
            title: 'Lead profile details',
            nextCallback: () => runDetailsCallback(job, jobs, reload),
            step: 1,
        }

        // not started if step 1 ispending or in progress
        let { stage, status } = job

        if (stage === 2) {
            switch (status) {
                case 'PROCESSING':
                    step = {
                        ...step,
                        status: 'processing',
                        description: 'In progress'
                    }
                    break;
                case 'DONE':
                    step = {
                        ...step,
                        status: 'done',
                        description: "Done"
                    }
                    break;

                case 'ERROR':
                    step = {
                        ...step,
                        status: 'error',
                        description: 'Error'
                    }

                    break;

                default:
                    step = {
                        ...step,
                        status: 'pending',
                        description: 'Not started',
                        nextText: "Start job"
                    }

            }
        } else if (stage < 2) {
            step = {
                ...step,
                status: 'waiting',
                description: "Not started",
                nextText: 'Collect details',
            }
        } else {
            step = {
                ...step,
                status: 'done',
                description: "Done"
            }
        }



        return step
    }

    // process step 3
    const getStep3 = (job) => {
        const { status, stage } = job
        let step = {
            title: 'Collect emails',
            nextCallback: () => collectEmailsCallback(job, jobs, reload),
            step: 2
        }

        if (stage === 3) {
            switch (status) {
                case 'PROCESSING':
                    step = {
                        ...step,
                        status: 'processing',
                        description: 'In progress'
                    }
                    break;
                case 'DONE':
                    step = {
                        ...step,
                        status: 'done',
                        description: "Done"
                    }
                    break;

                case 'ERROR':
                    step = {
                        ...step,
                        status: 'error',
                        description: 'Error'
                    }

                    break;

                default:
                    step = {
                        ...step,
                        status: 'pending',
                        description: 'Not started',
                        nextText: "Start job"
                    }

            }
        } else {
            return {
                ...step,
                status: 'waiting',
                description: 'Waiting',
            }
        }


        return step

    }

    const { promiseInProgress } = usePromiseTracker()

    useEffect(() => {
        // generate steps and the status
        if (job) {
            // get the first step
            if (job.tool_category == 'job') {
                const step1 = getJobStep1(job)
                const step2 = getJobStep2(job, step1)

                const steps = [step1, step2]
                setSteps(steps)
                setCurrentStep(job.stage)

            }
            else {
                const step1 = getStep1(job)
                const step2 = getStep2(job, step1)
                const step3 = getStep3(job, step2)

                const steps = [step1, step2, step3]
                setSteps(steps)
                setCurrentStep(job.stage)

            }

        }
    }, [job])

    // determine if next button is disabled
    const nextDisabled = () => {
        if (steps.length) {
            const step = steps[current - 1]

            const { status } = step

            return status === "processing"
        }
    }


    // get the control button
    const getButton = () => {
        const { status } = job

        if (status === 'PENDING') {
            // start the job
            return <Button type="primary" onClick={() => startJobCallback(job, jobs, reload)} icon={<PlayCircleOutlined />} loading={promiseInProgress}>Start job</Button>
        }

        // if job is in processing state
        if (status === "PROCESSING") {
            return <Button type="primary" onClick={() => message.info("Job is in progress.")} icon={<ClockCircleOutlined />} loading={promiseInProgress}>In Progress</Button>
        }

        // if in error state, callback will be previous step
        //        TODO @Shad please check error in this case
        //    if(status === "ERROR"){
        //        const step = steps[current - 1]
        //        return <Button type="primary" onClick={step.nextCallback} icon={<ExclamationOutlined />} loading={promiseInProgress}>Re-run step</Button>
        //    }

        //if job is done processing, and we have more stages, next should be current stage
        if (status === "DONE") {
            const step = steps[current]

            if (current < steps.length) {
                // more steps to run
                return <Button type="primary" onClick={step.nextCallback} icon={<StepForwardOutlined />} loading={promiseInProgress}>Next</Button>
            } else {
                return <Button type="primary" onClick={() => message.success("All steps are complete.")} icon={<CheckCircleOutlined />} >Compete</Button>
            }
        }
    }

    // get the current status
    const getStatus = () => {
        if (steps.length) {
            const step = steps[current - 1]

            const { status } = step

            switch (status) {
                case 'processing':
                    return 'process'
                case 'done':
                    return 'finish'
                case 'error':
                    return 'error'
                default:
                    return 'wait'

            }


        }
    }


    return (
        <Card className={classes.root} title="Contact scraping job progress">
            <Steps current={current - 1} status={getStatus()}>
                {
                    steps.map(item => (<Step key={item.step} title={item.title} description={<JobStatus status={item.status ? item.status : 'pending'} />} />))
                }
            </Steps>
            <div className={classes.action}>
                {getButton()}
            </div>
        </Card>
    )
}

MultiStepScheduler.propTypes = {
    /** show/hide scheduler */
    show: PropTypes.bool,
    /** Current contact job */
    job: PropTypes.object,
    /** Reload job details */
    reload: PropTypes.func
}

export const multiStepCallbacks = {
    'contact': [
        startJobCallback,
        runDetailsCallback,
        collectEmailsCallback,],
    'job': [
        startJobCallback,
        runCompanyDetailsCallback],
    'email': [startJobCallback],
    'lead_details': [startJobCallback],
    'developers': [startJobCallback],
    'company': [startJobCallback]
}


export default MultiStepScheduler
